/**
 * Resolve nama ibu dengan prioritas: data API > input tersimpan > input draft.
 */
export function resolveNamaIbu({
  nameMother,
  confirmedNameMother,
  manualNameMother,
}) {
  for (const value of [nameMother, confirmedNameMother, manualNameMother]) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return null;
}
